import CurrentInsurance from "./CurrentInsurance";
import { useGetCurrentInsuranceQuery } from "types/generated/operations";
import { getProspectUuid } from "utils/idHelpers";
import Loader from "uicomponents/Loader";
import ErrorPage from "uicomponents/Error";
import { getAppType } from "utils/helper";

interface ICurrentInsuranceModelProps {
  setNextStep: (submitApp?: boolean) => void;
  setPreviousStep: () => void;
}

const CurrentInsuranceModel = (
  props: ICurrentInsuranceModelProps
): JSX.Element => {
  const { data, error, loading } = useGetCurrentInsuranceQuery({
    variables: { uuid: getProspectUuid(), appType: getAppType() },
    fetchPolicy: "no-cache",
  });

  if (loading) {
    return <Loader />;
  }
  if (error) {
    return <ErrorPage />;
  }
  return (
    <CurrentInsurance
      data={data?.prospect}
      setNextStep={props.setNextStep}
      setPreviousStep={props.setPreviousStep}
    />
  );
};

export default CurrentInsuranceModel;
